import React, {useEffect, useState} from "react";
import {DynamicChart, SmartSelect, Grid, Typography, Skeleton} from "@leap4/frontend";
import {chartAxisFormatEnums as defaultFormatters, dataset, formatFunction} from "../../interfaces/chart.interfaces";

import {
    getDatasetsForGraph,
    getLabelsForGraph,
    getXAxisFormatFunc,
} from "./charts/charts";
import {EntitiesProperties} from "../../utils/enums";

const {COST, IMPRESSIONS, REQUESTS} = EntitiesProperties.NUMERIC.ALL
const optionalMetrics = [
    {name: 'Spent', value: COST},
    {name: 'Impressions', value: IMPRESSIONS},
    {name: 'Requests', value: REQUESTS}
]


export interface IOverviewGraphProps {
    isLoading: boolean;
    graphData: IOverviewGraphResponse
    startDate: string;
    endDate: string;
    tension?: number,
}

type axisFormatType = formatFunction | defaultFormatters

export interface graphData {
    time: string
    totals: {
        cost: number;
        impressions: number;
        requests: number;
    }
}


export interface IOverviewGraphResponse {
    data: Array<graphData>;
}

export default function OverviewGraph(props: IOverviewGraphProps) {
    const {
        isLoading,
        startDate,
        endDate,
        graphData,
        tension = 0.5,
    } = props
    const [labelsForGraph, setLabelsForGraph] = useState<string[]>([])
    const [selectedGraphDataProgressionIdx, setGraphDataProgressionIdx] = useState(0);
    const [selectedCompareIdx, setSelectedCompareIdx] = useState(1);
    const [datasets, setDatasets] = useState([])
    const [xAxisFormat, setXAxisFormat] = useState<axisFormatType>(null)
    const [yAxisFormat, setYAxisFormat] = useState<axisFormatType>(defaultFormatters.USD)

    const generateChartProps = () => {
        if (!graphData) return;
        const labels = getLabelsForGraph(startDate, endDate)
        setLabelsForGraph(labels)

        const xAxisFormat = getXAxisFormatFunc(startDate, endDate);
        setXAxisFormat(prevState => xAxisFormat)
        generateDatasetsAndAxisFormat()
    }

    useEffect(generateChartProps, [graphData, selectedCompareIdx, selectedGraphDataProgressionIdx]);
    const generateDatasetsAndAxisFormat = () => {
        if (!graphData) {
            return;
        }
        let currDatasets: dataset[] = []
        const selectedEntity = optionalMetrics[selectedCompareIdx].value
        switch (selectedCompareIdx) {
            case 0:
                currDatasets = getDatasetsForGraph(graphData, selectedEntity, startDate === endDate)
                setYAxisFormat(defaultFormatters.USD)
                break;
            case 1:
            case 2:currDatasets = getDatasetsForGraph(graphData, selectedEntity, startDate === endDate);
                setYAxisFormat(defaultFormatters.NUMBER)
                break;

        }
        setDatasets(currDatasets)
    }

    if (isLoading) {
        return <Skeleton variant={"rounded"} height={"100%"} animation={"wave"} sx={{borderRadius: "16px"}}/>
    }

    if (!graphData && isLoading) {
        return <Typography variant={"overline"}>No Data in the selected date range</Typography>
    }
    return (
        // <Grid container width={"100vw"}>
            <DynamicChart
                tension={tension}
                datasets={datasets} labels={labelsForGraph} axisFormat={{x: xAxisFormat, y: yAxisFormat} as any} title={"PERFORMANCE"}>
                <Grid container gap={'15px'} wrap={"nowrap"} >
                    <Grid>
                        <SmartSelect
                            selectProps={{size: "small"}}
                            items={optionalMetrics} selectedItemInd={selectedCompareIdx}
                            setSelectedState={(val) => setSelectedCompareIdx(val)}
                            title={"Metrics"}/>
                    </Grid>
                </Grid>
            </DynamicChart>
        // </Grid>
    )
}
